<script>
export default {
  props: {
    message: String
  },
}
</script>

<template>
  <div class="alert alert-danger my-3" role="alert">
    {{ message }}
  </div>
</template>